<footer class="footer-layout">
  <div class="footer-container">
    <!-- Main Footer Content -->
    <div class="footer-main">
      <!-- Company Info Section -->
      <div class="footer-section company-section">
        <div class="footer-logo">
          <img src="/assets/Complete-Pest-Control-Footer-Logo.svg" alt="Complete Pest Control" class="footer-logo-icon">
        </div>
        <p class="company-description">
          Professional pest control services for your home and business. 
          Protecting what matters most with safe, effective, and environmentally responsible solutions across Northern Utah.
        </p>
        <div class="contact-info">
          <div class="contact-item" (click)="callPhone()">
            <mat-icon>phone</mat-icon>
            <span>{{ config.phone.display }}</span>
          </div>
          <div class="contact-item" (click)="sendEmail()">
            <mat-icon>email</mat-icon>
            <span>{{ config.email }}</span>
          </div>
        </div>
      </div>

      <!-- Services Section -->
      <div class="footer-section">
        <h4 class="footer-title">Services</h4>
        <ul class="footer-links">
          <li><a (click)="navigateTo('/general-pest-control')">General Pest Control</a></li>
          <li><a (click)="navigateTo('/ant-control')">Ant Control</a></li>
          <li><a (click)="navigateTo('/spider-control')">Spider Control</a></li>
          <li><a (click)="navigateTo('/rodent-control')">Rodent Control</a></li>
          <li><a (click)="navigateTo('/mosquito-control')">Mosquito Control</a></li>
          <li><a (click)="navigateTo('/wasp-control')">Wasp Control</a></li>
        </ul>
      </div>

      <!-- Company Section -->
      <div class="footer-section">
        <h4 class="footer-title">Company</h4>
        <ul class="footer-links">
          <li><a (click)="navigateTo('/about')">About Us</a></li>
          <li><a (click)="navigateTo('/our-team')">Our Team</a></li>
          <li><a (click)="navigateTo('/service-areas')">Service Areas</a></li>
          <li><a (click)="navigateTo('/careers')">Careers</a></li>
          <li><a (click)="navigateTo('/contact')">Contact</a></li>
        </ul>
      </div>

      <!-- Resources Section -->
      <div class="footer-section">
        <h4 class="footer-title">Resources</h4>
        <ul class="footer-links">
          <li><a (click)="navigateTo('/pest-library')">Pest Library</a></li>
          <li><a (click)="navigateTo('/resources/prevention')">Prevention Tips</a></li>
          <li><a (click)="navigateTo('/blog')">Blog</a></li>
          <li><a (click)="navigateTo('/resources/faqs')">FAQs</a></li>
        </ul>
      </div>

      <!-- Get Started Section -->
      <div class="footer-section cta-section">
        <h4 class="footer-title">Ready for Pest-Free Living?</h4>
        <p class="cta-description">Get a free inspection and customized pest control plan today.</p>
        <p class="cta-description">Proudly serving home and businesses across Northern Utah including: Ogden • Layton • Clearfield • Roy • Syracuse • Clinton • Kaysville • Farmington • Bountiful • Salt Lake City • More</p>
        <button mat-raised-button class="footer-cta-btn" (click)="navigateTo('/contact')">
          <mat-icon>request_quote</mat-icon>
          Get a FREE Inspection
        </button>
        <button mat-button class="footer-phone-btn" (click)="callPhone()">
          <mat-icon>phone</mat-icon>
          Call Now
        </button>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <div class="footer-legal">
          <p>&copy; {{ currentYear }} {{ config.name }}. All rights reserved.</p>
          <div class="legal-links">
            <a (click)="navigateTo('/privacy')">Privacy Policy</a>
            <a (click)="navigateTo('/terms')">Terms of Service</a>
          </div>
        </div>
        
        <div class="social-links">
          <button mat-icon-button (click)="openSocialLink('facebook')" aria-label="Facebook">
            <mat-icon>facebook</mat-icon>
          </button>
          <button mat-icon-button (click)="openSocialLink('twitter')" aria-label="Twitter">
            <mat-icon>twitter</mat-icon>
          </button>
          <button mat-icon-button (click)="openSocialLink('instagram')" aria-label="Instagram">
            <mat-icon>instagram</mat-icon>
          </button>
          <button mat-icon-button (click)="openSocialLink('linkedin')" aria-label="LinkedIn">
            <mat-icon>linkedin</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</footer>